import { reactStrapStyles } from 'app/shared/util/form-utils';
import React from 'react';
import Select, { SingleValue } from 'react-select';

const timeWidgetArray = [
  { value: '-1h', label: 'Last hour' },
  { value: '-24h', label: 'Last 24 hours' },
  { value: '-2d', label: 'Last 2 days' },
  { value: '-3d', label: 'Last 3 days' },
  { value: '-4d', label: 'Last 4 days' },
  { value: '-5d', label: 'Last 5 days' },
  { value: '-6d', label: 'Last 6 days' },
  { value: '-7d', label: 'Last 7 days' },
  { value: '-14d', label: 'Last 14 days' },
  { value: '-30d', label: 'Last 30 days' },
  { value: '-90d', label: 'Last 90 days' },
] as const;

export type TimeRange = (typeof timeWidgetArray)[number]['value'];

type OptionType = {
  value: TimeRange;
  label: string;
};

type TimeRangeProps = {
  onChange: (timeRange: TimeRange) => void;
  timeRange: TimeRange;
};

const TimeRangeWidget = ({ onChange, timeRange }: TimeRangeProps) => {
  const selectedOption = timeWidgetArray.find(opt => opt.value === timeRange) || { value: '-7d', label: 'Last 7 days' };

  return (
    <Select<OptionType>
      classNamePrefix=""
      menuPlacement="auto"
      options={timeWidgetArray}
      styles={reactStrapStyles({ error: false })}
      value={selectedOption}
      onChange={(option: SingleValue<OptionType>) => {
        if (option) onChange(option.value);
      }}
    />
  );
};

export default TimeRangeWidget;
